import { MessageBox } from 'element-ui';
import { userLogin } from '@/apis/apis.js'
// 开启websocket
export const loginOrRegister = (ticket, callback) => {
  const is_support = ("WebSocket" in window)
  // 判断浏览器是否支持websocket
  if(is_support) {
    const ws = new WebSocket(`${userLogin}/1`);
    ws.onopen = function() { 
      console.log("WebSocket连接成功");
      ws.send(ticket);
    };
    ws.onmessage = (e) => {
      console.log(e);
      const data = JSON.parse(JSON.parse(JSON.stringify(e.data)))
      if(data.message === '邮箱验证成功') callback()    
    }
    ws.onerror = (ee) =>{
      console.log(ee);
    }
    ws.onclose = (res) =>{
      console.log('链接失败',res);
      loginOrRegister("1", callback);
    }
    callback(ws)
  } else {
    MessageBox('浏览器版本过低，请更新浏览器', "警告", {
      confirmButtonText: '确定',
      type:"error",
    })
  }
  
}
